<div class="search-wrapper">
  <nz-input-group [nzSuffix]="inputClearTpl" [nzPrefix]="suffixIconSearch">
    <input
      nz-input
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearch($event)"
      [placeholder]="placeholder" />
  </nz-input-group>

  <ng-template #inputClearTpl>
    @if (searchTerm) {
      <button
        type="button"
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        tabindex="0"
        aria-label="Clear search"
        (click)="clearSearch()"
        (keydown.enter)="clearSearch()"
        (keyup.enter)="clearSearch()"></button>
    }
  </ng-template>

  <ng-template #suffixIconSearch>
    <span nz-icon nzType="search"></span>
  </ng-template>
</div>
